import { runTaskInWorker } from './runTaskInWorker';

export const compile = async (code: string) => runTaskInWorker('compile', code);
